import React from "react";
import Icon from "react-icons-kit";
import { close } from "react-icons-kit/ionicons/close";
import AlertBox from "../../common/UI/AlertBox/AlertBox";
import failIcon from "../../../assets/images/fail.png";
import "../../../assets/css/components/Modal/Modal.css";

const ErrorModal = (props) => {
  let { modalVisibility, modalLabel, closeModalHandler, modalClass, messageContent } = props;
  return (
    <AlertBox
      alertVisibility={modalVisibility}
      closeAlertBoxHandler={closeModalHandler}
      alertClass={modalClass}
      backdrop={false}
      alertLabel={modalLabel}
    >
      <div className="modal-wrapper">
        <div className="text-right">
          <span onClick={closeModalHandler}>
            <Icon size={20} icon={close} />
          </span>
        </div>
        <div className="text-center mar">
          <img className="imge-fail" src={failIcon} alt="error" />
        </div>
        <p className="content-modal text-center">
          Message
            <br />
          <a className="btn btn-link">{messageContent}</a>
        </p>
        <div className="text-center">
          <button
            onClick={closeModalHandler}
            type="button"
            className="btn btn-org"
            id="doneButtonProfile"
          >
            Done
            </button>
        </div>
      </div>
    </AlertBox>
  );
}

export default ErrorModal;



// WEBPACK FOOTER //
// ./src/components/common/ErrorModal/ErrorModal.jsx